import React from "react";
import { EditUserWizardContextProvider } from "../context/editUserWizardContext ";
import EditUserWizardDialog from "./user/EditUserWizardDialog";

interface EditUserWizardProps {
  closeDialogHandler: () => void;
  updateUserHandler: (response: any, details: any) => void;
  userDetails: any;
  continueError?: string | null;
}


const EditUserWizard: React.FC<EditUserWizardProps> = ({
  closeDialogHandler,
  updateUserHandler,
  userDetails,
  continueError,
}) => {
  const updateTheUserHandler = (response: any, details: any) => {
    console.log("updateTheUserHandler", response, details);
    updateUserHandler(response, details);
  };

  return (
    <EditUserWizardContextProvider>
      <EditUserWizardDialog
        closeDialogHandler={closeDialogHandler}
        updateUserHandler={(response: any, details: any) => updateTheUserHandler(response, details)}
        userDetails={userDetails}
        errors={continueError}
      />
    </EditUserWizardContextProvider>
  );
};

export default EditUserWizard;
